import { Injectable } from '@angular/core';

@Injectable()
export class PriceDifferenceService {
    protected isPositive(x: number): boolean {
        return Math.sign(x) > -1;
    }

    protected calculateDifference(base: number | string, difference: number | string, inverted?: boolean): number {
        return !inverted ? +difference - +base : +base - +difference;
    }

    protected sumValues(base: number | string, difference: number | string): number {
        return +base + Math.abs(+difference);
    }
}
